import { useState, useEffect, FC } from "react";
import { GenericStoryElementComponentProps, GenericStorylineElementsList } from "../GeneralComponents/generic-storyline-list";
import { StoryElement } from "../storyelements-management/story-element";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import { Paper, TextField, Checkbox, Box, Button, CircularProgress } from "@mui/material";
import { useDebounce } from "@uidotdev/usehooks";
import Link from "next/link";
import { link } from "fs";

const GARChannelSetter:FC<GenericStoryElementComponentProps> = ({ storyElement, updateListFromServer }) => {

    const [titleOverride, setTitleOverride] = useState(storyElement.garTitleOverride?storyElement.garTitleOverride:"");
    const [includeInGAR, setIncludeInGAR] = useState(storyElement.gar?storyElement.gar: false);
    const [garDraftDate, setGARDraftDate] = useState(storyElement.garDraftDate);
    const titleOverrideDebounced = useDebounce(titleOverride, 1000);

    useEffect(() => {
        const newStoryElement = {
            ... storyElement,
            gar: includeInGAR,
            garTitleOverride: titleOverrideDebounced,
            garDraftDate: garDraftDate,
        }

        StorylineServerProxy.updateStoryElement(newStoryElement)?.then(updateListFromServer);
    }, [titleOverrideDebounced, includeInGAR, garDraftDate])

    function handleTitleOverrideChanged(event: any){
        setTitleOverride(event.target.value);
    }

    function handleIncludeInGARChanged(event: any){
        setIncludeInGAR(event.target.checked);
    }

    function handleCreateGARDraftClicked(){
        setGARDraftDate(new Date().toISOString().substring(0, 19).replace("T", " "));
    }

    return(
        <>
            <Paper elevation={6}  sx={{ padding: 3, margin:0}}>
                {
                    storyElement.type == "News"?<Checkbox checked={includeInGAR} onChange={handleIncludeInGARChanged}></Checkbox>:<></>
                }
                <Link href={ storyElement.link } target="child">{ storyElement.title }</Link>
                <TextField value={titleOverride} onChange={handleTitleOverrideChanged} sx={{ width: 9/10 }} placeholder="Title override"></TextField>
                <br/>
                { storyElement.description }
                <br />
                <Button onClick={handleCreateGARDraftClicked}>Create draft in GAR</Button>
                { storyElement.garDraftDate?<> Draft created on the { storyElement.garDraftDate }<br/></>:<></>}
            </Paper>
        </>
    )
}


export default function GARSetterPage(filter: any){

    let [storyElements, setStoryElements] = useState([] as StoryElement[]);

    function reloadFromServer(){
        StorylineServerProxy.getFilteredStoryElements(filter.filter, 50, 0).then(elements => { setStoryElements(elements); } )
    }

    useEffect(() => {
        reloadFromServer();
    }, [filter]);

    return (
       <GenericStorylineElementsList storyElements={storyElements} Component={GARChannelSetter} updateListFromServer={reloadFromServer} />
    )
}
